import { EventBus } from 'pdfjs-dist/lib/web/ui_utils';
export default new EventBus();


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-pdf/dist/esm/eventBus.js
// module id = 692
// module chunks = 0